import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, TextField, MenuItem, Select, Tooltip, Menu, IconButton, Checkbox, FormControl, Autocomplete, ListSubheader} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useParams } from "react-router-dom";
import { CiFilter, CiImport, CiExport } from "react-icons/ci";
import SearchBar from "../../SearchBar";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import { ExpandMore } from "@mui/icons-material";
import { BsThreeDotsVertical } from "react-icons/bs";
import { deleteCommentEntities, fetchEntityById, newFilterEntities } from "../../../apis/apiService";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/Loader";
import dayjs from "dayjs";
import { setIssueNameOptions } from "../../../selectSlice";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import { useFetchGetAllProjectBasedUserNameListQuery, useFetchMilestoneBasedIsuueFilterQuery, useFetchProjectBasedIsuueFilterQuery } from "../../../slice/logdetailSlice";
import CommonDeleteDialog from "../../common/CommonDelete";
import ImportTimesheet from "../../common/TimesheetImport";
import { usePersistentFilter } from "../../../assets/hooks/usePersistentFilter";
import { CommonAddIssue } from "../../common/Issue/CommonAddIssue";
import { FilterSummaryBox } from "../../common/FilterSummaryBox";
import CommonTaskIssueNameChamge from "../../common/CommonTaskIssueNameChamge";
import { validateEndDate, validateStartDate } from "../../common/PreventValidate";
import { useTheme } from "../../../ThemeContext";
import { CommonIssueExport } from "../../common/Issue/CommonIssueExport";
import IssueBoard from "./IssueBoard";
import { openInNewTab } from "../../../utils/openInNewTab";


export const IssueFilterComponent = ({
  onApply,
  onClear,
  onCancel,
  filter_path,
  refetch_list,
  filter_id,
  isMilestone,
  milestone_id,
  isBoard,
  filter_type_id,
}) => {

  // const [isSubmitting, setIsSubmitting] = useState(false);
  const { id: project_id } = useParams();
  // console.log("id_data", project_id);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const projectNames = useSelector(
    (state) => state.selectOptions.ProjectNameOptions
  );
  const filterdata = sessionStorage.getItem(isBoard ? "board_issue_filter_data" : "issue_filter_data");
  const sessionFilter = JSON.parse(filterdata);
  // const { handleSubmit, control, reset, watch, setValue } = useForm({
  const { handleSubmit, control, reset, setValue, getValues, formState: { errors } } = useForm({
    defaultValues: {
      issueName: sessionFilter?.title || [],
      Reporter: sessionFilter?.added_by || "",
      Assignee: sessionFilter?.assignee || "",
      createdBy: sessionFilter?.added_by || "",
      // createdDate: sessionFilter?.created_date || null,
      createdDate: sessionFilter?.created_date ? dayjs(sessionFilter.created_date) : null,
      lastModifiedBy: sessionFilter?.last_modified_by || "",
      startDate: sessionFilter?.start_due_date
        // ? sessionFilter?.start_due_date
        ? dayjs(sessionFilter.start_due_date): null,
      // endDate: sessionFilter?.end_due_date ? sessionFilter?.end_due_date : null,
      endDate: sessionFilter?.end_due_date ? dayjs(sessionFilter.end_due_date) : null,
      Severity: sessionFilter?.severity_id || null,
      Module: "",
      status: sessionFilter?.current_status_id || null,
    },
  });

  // const reporterOptions = useSelector(
  //   (state) => state.selectOptions?.userNamesByProjects
  // );
  const { data: reporterOptions } = useFetchGetAllProjectBasedUserNameListQuery(
    isMilestone ? milestone_id : project_id,
    { skip: isMilestone ? !milestone_id : !project_id }
  );
  // console.log("reporterOptions", reporterOptions);

  const statusOptions = useSelector(
    (state) => state.selectOptions?.StatusOptions
  );

  const statusNames = statusOptions.find(
    (statusName) => statusName.status_type === "ISSUE"
  );

  const statusList = statusNames?.status_details?.map((statusList) => ({
    id: statusList.status_id,
    status_name: statusList.status_name,
    status_colour: statusList.status_colour,
  }));
  //console.log()("StatusList: ", statusList);

  const serverityOptions = useSelector(
    (state) => state.selectOptions.SeverityNameOptions
  );
  // const issueNameList = useSelector(
  //   (state) => state.selectOptions.issueNameOptions
  // );
  // useFetchProjectBasedIsuueFilterQuery
  //console.log()("issue_name_list_in_selector :", issueNameList);
  const { data: milestoneBased_issueNameList } =
    useFetchMilestoneBasedIsuueFilterQuery(milestone_id, {
      skip: !milestone_id,
    });

  const { data: projectBaes_issueNameList } =
    useFetchProjectBasedIsuueFilterQuery(project_id, { skip: !project_id });

  const fetchAllIssues = async () => {
    try {
      const response = await fetchEntityById("issuesInProjects", project_id);
      //console.log()("issue_name_list_in_selector dispatch :", response.data);
      dispatch(setIssueNameOptions(response.data));
    } 
    catch (error) {
      console.error("Error fetching issues:", error);
    }
  };

  useEffect(() => {
    fetchAllIssues();
  }, []);

  const onSubmit = async (data) => {
    const hasActiveFilter = 
      (data.issueName && data.issueName.length > 0) ||
      data.Reporter ||
      data.Assignee ||
      data.createdBy ||
      data.createdDate ||
      data.lastModifiedBy ||
      data.startDate ||
      data.endDate ||
      data.Severity ||
      data.Module ||
      data.status;

    if (!hasActiveFilter) {
      toast.info("No filter values selected. Select one or more filters to apply");
      return;
    }

    //console.log()("data_in_onSubmit :", data);
    const requestedData = {
      title: data.issueName, // Assuming you want the first selected title
      added_by: parseInt(data.Reporter, 10) || null, // Ensure numeric ID
      assignee: data.Assignee,
      start_due_date: data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      end_due_date: data.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
      // billing_type: data.billingType || null,
      created_by: parseInt(data.added_by, 10) || null,
      current_status_id: data.status || null,
      created_date: data.createdDate
        ? format(new Date(data.createdDate), "yyyy-MM-dd")
        : null,
      severity_id: data.Severity,
      last_modified_by: data.lastModifiedBy
        ? parseInt(data.lastModifiedBy, 10)
        : null,
      module: data.Module,
    };
    if (isBoard) {
      requestedData.view_type_id = filter_type_id;
    }
    setLoading(true);
    //console.log()(" data_in_onSubmit requested_data :", requestedData);

    //console.log()("datass :", data);
    try {
      const response = await newFilterEntities(
          filter_path,
          isMilestone ? milestone_id : project_id,
          requestedData
        );
      if (response.data) {
        if (isBoard) {
          sessionStorage.setItem("isBoardIssueFilterApplied", true);
          sessionStorage.setItem(
            "board_issue_filter_data",
            JSON.stringify(requestedData)
          );
        } 
        else {
          sessionStorage.setItem("isIssueFilterApplied", true);
          sessionStorage.removeItem("isTaskFilterApplied");
          sessionStorage.removeItem("isMilestoneFilterApplied");
          sessionStorage.removeItem("isFilterApplied");
          sessionStorage.setItem(
            "issue_filter_data",
            JSON.stringify(requestedData)
          );
        }
        onApply(response.data);
        toast.success("Issue filter applied successfully!");
      }

      // onApply(filterIssues);
    } 
    catch (err) {
      const errorMsg = err.message;
      console.error(err);
      toast.error(errorMsg);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    reset({
      issueName: [],
      Reporter: "",
      Assignee: "",
      createdBy: "",
      createdDate: null,
      lastModifiedBy: "",
      startDate: null,
      endDate: null,
      Severity: null,
      Module: "",
      status: null,
    });
    if (onClear) onClear();
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Filter
          </div>
        </button>

        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red clear-filter-btn"
          >
            Clear Filter
          </button>
        </div>
      </div>

      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="pb-5">
              {/* Search by Issues */}
              <div className="row mb-3">
                <div className="col-12">
                  <label htmlFor="issueName" className="form-label">
                    Search by Issues
                  </label>
                  <Controller
                    name="issueName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="issueName"
                        options={
                          isMilestone
                            ? milestoneBased_issueNameList || []
                            : projectBaes_issueNameList || []
                        }
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.title}
                        value={(value || [])
                          .map((title) =>
                            (isMilestone
                              ? milestoneBased_issueNameList
                              : projectBaes_issueNameList
                            )?.find((item) => item.title === title)
                          )
                          .filter(Boolean)}
                        onChange={(event, newValue) => {
                          const selectedTitles = newValue.map(
                            (user) => user.title
                          );
                          onChange(selectedTitles);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.title}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter issue name"
                            fullWidth
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3 ">
                <div className="col-md-6">
                  <label htmlFor="Reporter" className="form-label">
                    Reporter
                  </label>
                  <Controller
                    control={control}
                    name="Reporter"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          labelId="Reporter"
                          {...field}
                          id="Reporter"
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              reporterOptions?.find(
                                (list) => list.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {reporterOptions?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="Assignee" className="form-label">
                    Assignee
                  </label>
                  <Controller
                    name="Assignee"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              reporterOptions?.find(
                                (list) => list.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          labelId="Assignee-label"
                          id="Assignee"
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {reporterOptions?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}

                          {/* Add other options as needed */}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              {/* Created Date & Created By */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="createdDate" className="form-label">
                    Created Date
                  </label>
                  <Controller
                    name="createdDate"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (!val) return true;
                        const d = dayjs(val);
                        if (!d.isValid()) return "Invalid date";
                        if (d.year() < 1900) return "Invalid date format";
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <>
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          className="w-100"
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <input
                              className="form-control datepic_ip"
                              {...params}
                            />
                          )}
                        />
                        {errors.createdDate && (
                          <span className="errorMsg">
                            {errors.createdDate.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="createdBy" className="form-label">
                    Created By
                  </label>
                  <Controller
                    name="createdBy"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          labelId="createdBy-label"
                          id="createdBy"
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              reporterOptions?.find(
                                (list) => list.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {reporterOptions?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}

                          {/* Add other options as needed */}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              {/* Last Modified By & Status */}
              <div className="row mb-3">
                {/*  */}
                <div className="col-md-6">
                  <label htmlFor="lastModifiedBy" className="form-label ">
                    Last Modified By
                  </label>
                  <Controller
                    control={control}
                    name="lastModifiedBy"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              reporterOptions?.find(
                                (list) => list.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          labelId="lastModifiedBy-label"
                          id="lastModifiedBy"
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {reporterOptions?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <Controller
                    name="status"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Controller
                          name="status"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              value={field.value || ""}
                              onChange={(e) => {
                                field.onChange(e.target.value); // Update form state
                                setValue("status", e.target.value); // Optionally set value
                              }}
                              displayEmpty
                              renderValue={(selected) => {
                                const selectedValue = statusList?.find(
                                  (statusName) => statusName.id === selected
                                );
                                return selectedValue ? (
                                  <span
                                    style={{
                                      color: selectedValue.status_colour,
                                    }}
                                  >
                                    {selectedValue.status_name}
                                  </span>
                                ) : (
                                  <span className=" lightText">
                                    Select status
                                  </span>
                                );
                              }}
                              IconComponent={ExpandMoreIcon}
                            >
                              {statusList.map((status, index) => (
                                <MenuItem
                                  key={index}
                                  style={{
                                    color: status.status_colour || "black",
                                  }}
                                  value={status.id}
                                >
                                  {status.status_name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              {/* Start Date & End Date */}
              <div className="row mb-3">

                <div className="col-md-6">
                  <label htmlFor="startDate" className="form-label">
                    Start Date
                  </label>
                  <Controller
                    name="startDate"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (!val) return true;
                        const d = dayjs(val);
                        if (!d.isValid()) return "Invalid date";
                        if (d.year() < 1900) return "Invalid date format";
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <>
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          className="datepicker_input w-100"
                          onChange={(date) => {
                            const endDate = getValues("endDate");
                            if (date && endDate && !validateStartDate(date, endDate)) {
                              const current = getValues("startDate");
                              setValue("startDate", null);
                              setTimeout(() => setValue("startDate", current), 0);
                              return;
                            }
                            field.onChange(date);
                          }}
                          renderInput={(params) => (
                            <input
                              className="form-control datepicker_input"
                              {...params}
                            />
                          )}
                        />
                        {errors.startDate && (
                          <span className="errorMsg">
                            {errors.startDate.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="endDate" className="form-label">
                    End Date
                  </label>
                  <Controller
                    name="endDate"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (!val) return true;
                        const d = dayjs(val);
                        if (!d.isValid()) return "Invalid date";
                        if (d.year() < 1900) return "Invalid date format";
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <>
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          className="w-100"
                          onChange={(date) => {
                            const startDate = getValues("startDate");
                            if (date && startDate && !validateEndDate(startDate, date)) {
                              const current = getValues("endDate");
                              setValue("endDate", null);
                              setTimeout(() => setValue("endDate", current), 0);
                              return;
                            }
                            field.onChange(date);
                          }}
                          renderInput={(params) => (
                            <input
                              className="form-control datepic_ip"
                              {...params}
                            />
                          )}
                        />
                        {errors.endDate && (
                          <span className="errorMsg">
                            {errors.endDate.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
              </div>

              {/* <div className="row paddingBtn  mb-3"> */}
              {/* Severity */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="Severity" className="form-label">
                    Severity
                  </label>
                  <Controller
                    name="Severity"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          labelId="Severity-label"
                          id="Severity"
                          displayEmpty
                          renderValue={(selected) => {
                            const selected_value = serverityOptions?.find(
                              (list) => list.severity_id === selected
                            );
                            return selected_value ? (
                              <span
                                style={{
                                  color:
                                    selected_value.severity_colour || "black",
                                }}
                              >
                                {selected_value.severity_name}
                              </span>
                            ) : (
                              <span className="lightText">Select severity</span>
                            );
                          }}
                          // {...control.register("Severity")}
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {serverityOptions.map((list, index) => (
                            <MenuItem
                              key={index}
                              sx={{ color: list.severity_colour }}
                              value={list.severity_id}
                            >
                              {list.severity_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                {/* <div className="col-md-6">
                  <label htmlFor="Module" className="form-label">
                    Module
                  </label>
                  <Controller
                    control={control}
                    name="Module"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          labelId="Module-label"
                          id="Module"
                          {...field}
                          IconComponent={ExpandMore} // Add the custom icon here
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              // reporterOptions?.find(
                              //   (list) => list.user_id === selected
                              // )?.name
                              <span className="lightText">Module</span>
                            )
                          }
                        >
                          <MenuItem value="Module">Select Type</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div> */}
              </div>

              <div className="d-flex py-3 w-100 align-items-center position-absolute bottom-0 bg-white mt-3">
                <button
                  type="submit"
                  className="me-3 add_btn"
                  disabled={loading}
                >
                  {loading ? "Applying..." : "Apply"}
                </button>
                <button
                  type="button"
                  className="cancel_btn"
                  onClick={(event) => {
                    event.preventDefault();
                    onCancel();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const IssueTab = ({ ProjectID }) => {
  const { isDarkMode } = useTheme();
  const [expandedRows, setExpandedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  // const [filter, setFilter] = useState(6);
  const [Issues, setIssues] = useState([]);
  const [boardIssues, setBoardIssues] = useState([]);
  const [issue_creator, set_issue_creator] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [boardSearchTerm, setBoardSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showImport, setShowImport] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [menuOpen, setMenuOpen] = useState(null);
  const open = Boolean(menuOpen);
  // const [filters, setfilters] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const { id: project_id } = useParams();
  // const project_id = localStorage.getItem("project_id");
  //console.log()("project_id_in_milestone :", project_id);

  const navigate = useNavigate();
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log()("login_user in task:", login_user);
  const { role: login_user_role, id: login_user_id } = login_user;
  //console.log()("login_user role in task:", login_user_role);
  const { reset } = useForm();
  const [filter, setFilter] = usePersistentFilter(
    "projectIssueFilter",
    login_user_role === "CLIENT" || login_user_role === "ADMIN" ? 1 : 6
  );
  const [viewMode, setViewMode] = usePersistentFilter(
    "projectIssueViewMode",
    "list"
  );
  function generateUniqueId() {
    return Date.now().toString(36);
  }

  const uniqueId = generateUniqueId();
  //console.log()("uniqueId", uniqueId);

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          {/* More options button */}
          <IconButton
            onClick={(event) => {
              handleMenuOpen(event, params.row); // Open menu for the row
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
      ),
    },
    { field: "id", 
      headerName: "ID",
      width: 150 
    },
    { field: "title", 
      headerName: "Issue", 
      width: 150 
    },
    { field: "module", 
      headerName: "Module", 
      width: 200 
    },
    { field: "reporter", 
      headerName: "Reporter", 
      width: 150 
    },
    { field: "assignee", 
      headerName: "Assignee", 
      width: 150 
    },
    { field: "due_date", 
      headerName: "Due Date", 
      width: 170 
    },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 180,
      renderCell: (params) => {
        const status = params.value;
        let color = params.row.status_colour;
        return (
          <Box sx={{ color: color, padding: "4px 8px", borderRadius: "4px" }}>
            {status}
          </Box>
        );
      },
    },
    {
      field: "priority_name",
      headerName: "Priority",
      width: 170,
      renderCell: (params) => {
        const status = params.value;
        let color = params.row.priority_colour;
        return (
          <Box sx={{ color: color, padding: "4px 8px", borderRadius: "4px" }}>
            {status}
          </Box>
        );
      },
    },
    {
      field: "severity_name",
      headerName: "Severity",
      width: 170,
      renderCell: (params) => {
        const status = params.value;
        let color = params.row.severity_colour;
        return (
          <Box sx={{ color: color, padding: "4px 8px", borderRadius: "4px" }}>
            {status}
          </Box>
        );
      },
    },
    {
      field: "added_by_name",
      headerName: "Created By",
      width: 180,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.reporter || params.value || "-"}
          </Box>
        );
      },
    },
    {
      field: "added_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    {
      field: "updated_name",
      headerName: "Updated By",
      width: 180,
      renderCell: (params) => {
        return (
          <Box>
            {params.value || "-"}
          </Box>
        );
      },
    },
  ];

  const filteredIssues = React.useMemo(() => {
    if (!searchTerm) return Issues;
    const lowerSearch = searchTerm.toLowerCase();
    return Issues.filter((issue) =>
      (issue.title || "").toLowerCase().includes(lowerSearch) ||
      (issue.reporter || "").toLowerCase().includes(lowerSearch) ||
      (issue.id || "").toString().toLowerCase().includes(lowerSearch) ||
      (issue.current_status_name || "").toLowerCase().includes(lowerSearch) ||
      (issue.module || "").toLowerCase().includes(lowerSearch) ||
      (issue.assignee || "").toLowerCase().includes(lowerSearch) ||
      (issue.issue_id || "").toString().toLowerCase().includes(lowerSearch)
    );
  }, [Issues, searchTerm]);


  const fetchIssues = async (targetView = "both") => {
    setLoading(true);
    try {
      const requestedData = { view_type_id: filter, };
      const response = await newFilterEntities( "issue/show", ProjectID, requestedData);
      if (response?.issues) {
        const data = response.issues.map((issue) => ({
          ...issue,
          id: issue.id || issue.issue_id,
        }));
        if (targetView === "both" || targetView === "list") {
          setIssues(data);
        }
        if (targetView === "both" || targetView === "board") {
          setBoardIssues(data);
        }
      } 
      else {
        console.error("No issues found in the response.");
      }
    } 
    catch (error) {
      console.error("Error fetching issues:", error);
    } 
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("isIssueFilterApplied", false);
    sessionStorage.removeItem("issue_filter_data");
    sessionStorage.setItem("isBoardIssueFilterApplied", false);
    sessionStorage.removeItem("board_issue_filter_data");
    fetchIssues("both");
  }, [ProjectID, filter]);

  const handleShowFilter = () => setShowFilter(true); // Open filter
  const handleShowProject = () => setShowProject(true); // Open filter

  const toggleExpandRow = (taskId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };
  const handleMenuOpen = (event, row) => {
    event.stopPropagation(); // Prevent row click event
    setMenuAnchorEl(event.currentTarget); // Open the menu
    // console.log("issue_rows :", row);

    setSelectedTask(row); // Store the selected task ID
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null); // Clear the selected task ID
  };
  const handleShowImport = () => {
    setShowImport(true); // Open filter
    handleCloseMenu();
  };
  const handleCloseMenu = () => {
    setMenuOpen(null);
  };
  const handleOpenMenu = (event) => {
    setMenuOpen(event.currentTarget);
  };
  const handleImport = () => {
    reset();
  };
  const handleClone = () => {
    //console.log()(`Clone task: ${selectedTask}`);
    handleMenuClose();
  };

  const handleView = () => {
    //console.log()(`View task: ${selectedTask}`);
    handleMenuClose();
    navigate(
      `/projects/projectDetail/${selectedTask?.project_id}/issue/IssueDetail/${selectedTask?.id}`
    );
  };
  const handleViewDitailstab = () => {
    //console.log()(`View task on new tab: ${selectedTask}`);
    const newPath = `/projects/projectDetail/${selectedTask?.project_id}/issue/IssueDetail/${selectedTask?.id}`;
    openInNewTab(newPath);
    handleMenuClose();
  };
  const handleDeleteIssue = async () => {
    try {
      const response = await deleteCommentEntities(
        "issue/delete",
        selectedTask?.id
      );
      toast.success(response.message);
      fetchIssues(); // Refresh the issues after deleting
    } catch (err) {
      console.error("Failed to delete task:", err);
      toast.error(err.message);
    } finally {
      handleMenuClose(); // Close the menu after performing the action
    }
  };

  const filterOptions = {
    predefined: [
      { label: "All Issue", value: 1 },
      { label: "All Open", value: 2 },
      { label: "All Re Open", value: 11 },
      { label: "All Closed", value: 3 },
      { label: "All Overdue & Open", value: 4 },
      { label: "Unassigned", value: 5 },
      // { label: "Unscheduled Tasks", value: "unscheduled" },
      // { label: "Closed Task Lists", value: "closed_task_lists" },
    ],
    myViews: [
      { label: "My Open", value: 6 },
      { label: "My Re Open", value: 12 },
      { label: "My Closed", value: 7 },
      // { label: "My Overdue & Open", value: "my_overdue_open" },
      { label: "Today's Issue", value: 8 },
      { label: "Issue I Follow", value: 9 },
      { label: "Issue Created By Me", value: 10 },
      // { label: "Assigned Via Pick List", value: "assigned_via_pick_list" },
    ],
  };

  const handleFilterChange = async (event) => {
    const value = event.target.value;
    //console.log()("filter_values :", value);
    const requestedData = {
      view_type: value,
    };
    //console.log()("filter_values :", requestedData);
    setFilter(value);
  };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };
  const handleApplyFilter = (filteredData) => {
    setIssues(
      filteredData.map((project) => ({
        ...project,
        id: project.issue_id, // Ensure DataGrid has a unique ID
      }))
    );
    setShowFilter(false); // Close filter sidebar
    setClearFilter(true);
  };

  const handleApplyBoardFilter = (filteredData) => {
    setBoardIssues(
      filteredData.map((project) => ({
        ...project,
        id: project.issue_id, // Ensure Kanban has a unique ID
      }))
    );
    setShowFilter(false); // Close filter sidebar
    setClearFilter(true);
  };

  // Handle row click
  const handleRowClick = (params) => {
    const { id } = params.row;
    setSelectedRow(params.row);
    navigate(`/projects/projectDetail/${project_id}/issue/IssueDetail/${id}`);
  };

  // const handleAddIssue = async (newIssue) => {
  //   const formattedIssue = { ...newIssue, id: newIssue.issue_id }; // Map issue_id to id
  //   setIssues((prevIssues) => [...prevIssues, formattedIssue]);
  //   await fetchIssues();
  // };
  const handleIssueAdded = (newIssue) => {
    setIssues((prevIssues) => [...prevIssues, newIssue]);
  };
  useEffect(() => {
    const issue_data = Issues?.map((user) => set_issue_creator(user.added_by));
    //console.log()("issue_asigner :", issue_data);
  }, [Issues]);
  // //console.log()("issue_asigner :", Issues);
  //console.log()("matching_user :", Issues);

  const handleClearFilter = () => {
    fetchIssues("list");
    sessionStorage.setItem("isIssueFilterApplied", false);
    sessionStorage.removeItem("issue_filter_data");
    setClearFilter(false);
  };

  const handleClearBoardFilter = () => {
    fetchIssues("board");
    sessionStorage.setItem("isBoardIssueFilterApplied", false);
    sessionStorage.removeItem("board_issue_filter_data");
    setClearFilter(false);
  };

  useEffect(() => {
    const isIssueApplied = sessionStorage.getItem("isIssueFilterApplied") === "true";
    const isBoardApplied = sessionStorage.getItem("isBoardIssueFilterApplied") === "true";

    if (viewMode === "list") {
      setClearFilter(isIssueApplied);
    } 
    else {
      setClearFilter(isBoardApplied);
    }
  }, [viewMode, Issues, boardIssues]);

  useEffect(() => {
    sessionStorage.setItem("isIssueFilterApplied", false);
    sessionStorage.removeItem("issue_filter_data");
    sessionStorage.setItem("isBoardIssueFilterApplied", false);
    sessionStorage.removeItem("board_issue_filter_data");
  }, []);

  return (
    <>
      {/* Add  Project */}
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {/* <AddIssueComponent
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            // onIssueAdded={handleIssueAdded}
            setIssues={setIssues}
            Issues={Issues}
            proid={ProjectID}
            fetchIssues={fetchIssues}
          /> */}
          <CommonAddIssue
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            // Issues={Issues}
            fetchIssues={fetchIssues}
            path="issue"
            project_id={project_id}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      {/* Add filter */}
      <Offcanvas
        show={showFilter}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <IssueFilterComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
            filter_path="issue/filter"
            onApply={viewMode === "board" ? handleApplyBoardFilter : handleApplyFilter}
            refetch_list={fetchIssues}
            onClear={viewMode === "board" ? handleClearBoardFilter : handleClearFilter}
            onCancel={() => setShowFilter(false)}
            isMilestone={false}
            isBoard={viewMode === "board"}
            filter_type_id={filter}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <Offcanvas
        show={showImport}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {/* <AddIssueComponent
                  onClear={() => reset()} // Resets to initial values
                  onCancel={() => setShowProject(false)}
                  Issues={Issues}
                  fetchIssues={issue_module_refetch}
                /> */}
          <ImportTimesheet
            // onClear={() => reset()} // Resets to initial values
            // onCancel={() => setShowImport(false)}
            // Issues={Issues}
            // fetchIssues={issue_module_refetch}
            onCancel={() => setShowImport(false)}
            refetchList={fetchIssues}
            // isModule={true}
            onDocumentAdded={handleImport}
            importPath="importIssues"
            project_id={project_id}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <Offcanvas
        show={showExport}
        onHide={() => setShowExport(false)}
        placement="end"
        style={{ width: "50%" }}
      >
        <Offcanvas.Body className="p-0">
          <CommonIssueExport
            onCancel={() => setShowExport(false)}
            IssuesList={Issues}
            refetchList={fetchIssues}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <div style={{ padding: "9px 16px" }} className="bg-white">
        <Box
          className="row align-items-center"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "9px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
            mx: 0,
          }}
        >
          <div className="col-12 col-lg-4 col-md-5 d-flex gap-3 align-items-center" style={{ paddingLeft: 0 }}>
            <FormControl className="" size="small" sx={{ width: "auto" }}>
              {login_user_role !== "CLIENT" && (
                <Select
                  value={filter}
                  onChange={handleFilterChange}
                  displayEmpty
                  size="small"
                >
                  <ListSubheader className="ps-3 text-rgba-gray">
                    Predefined Views
                  </ListSubheader>
                  {filterOptions.predefined.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}

                  <ListSubheader className="ps-3 text-rgba-gray">
                    My Views
                  </ListSubheader>
                  {filterOptions.myViews.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FormControl>

            {login_user_role !== "CLIENT" && (
              <div className="d-flex align-items-center" style={{ gap: "4px", alignSelf: "center" }}>
                <Tooltip title="Table View">
                  <IconButton
                    onClick={() => {
                      setViewMode("list");
                    }}
                    sx={{
                      backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                      color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                      border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                      borderRadius: "4px",
                      height: "34px",
                      width: "75px",
                      gap: "4px",
                      fontSize: "13px",
                      fontWeight: 500,
                      marginRight: "10px",
                      "&:hover": {
                        backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  >
                    <CiViewList size={18} />
                    Table
                  </IconButton>
                </Tooltip>

                <Tooltip title="Board View">
                  <IconButton
                    onClick={() => {
                      setViewMode("board");
                    }}
                    sx={{
                      backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                      color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                      border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                      borderRadius: "4px",
                      height: "34px",
                      width: "75px",
                      gap: "4px",
                      fontSize: "13px",
                      fontWeight: 500,
                      "&:hover": {
                        backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  >
                    <MdViewQuilt size={18} />
                    Board
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </div>

          <div className="col-12 col-lg-8 col-md-7 d-flex flex-wrap justify-content-md-end gap-2 align-items-center" style={{ paddingRight: 0 }}>
            <SearchBar
              placeholder="Search issue"
              searchTerm={viewMode === "board" ? boardSearchTerm : searchTerm}
              onSearchChange={(e) => {
                if (viewMode === "board") {
                  setBoardSearchTerm(e?.target?.value || "");
                } else {
                  handleSearchChange(e);
                }
              }}
            />

            {clearFilter && (
              <button
                type="button"
                className="addmore_btn"
                disabled={loading}
                onClick={viewMode === "board" ? handleClearBoardFilter : handleClearFilter}
              >
                Clear filter
              </button>
            )}

            {login_user_role !== "CLIENT" && (
              <Button
                className="AddButton rounded me-2 ms-2"
                onClick={handleShowProject}
              >
                Add Issues
              </Button>
            )}

            <Tooltip title="Filter">
              <IconButton
                onClick={handleShowFilter}
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  width: "39px",
                  height: "39px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                  marginRight: "2px",
                  marginLeft: "10px",
                }}
              >
                <CiFilter className="text-rgbr-blue pro-icon-s" />
              </IconButton>
            </Tooltip>

            <Tooltip title="More Options">
              <IconButton
                onClick={handleOpenMenu}
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  width: "39px",
                  height: "39px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                  marginRight: "2px",
                }}
              >
                <BsThreeDotsVertical className="text-rgbr-blue pro-icon-s" />
              </IconButton>
            </Tooltip>
            <Menu anchorEl={menuOpen} open={open} onClose={handleCloseMenu}>
              <MenuItem>
                {login_user_role !== "CLIENT" && (
                  <div
                    onClick={handleShowImport}
                    className="d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    <CiImport className="text-rgbr-blue pro-icon-s me-2" />{" "}
                    <span>Import</span>
                  </div>
                )}
              </MenuItem>

              <MenuItem>
                <div
                  onClick={() => {
                    setShowExport(true);
                    handleCloseMenu();
                  }}
                  className="d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                >
                  <CiExport className="text-rgbr-blue pro-icon-s me-2" />{" "}
                  <span>Export</span>
                </div>
              </MenuItem>
            </Menu>
          </div>
        </Box>

        {loading ? (
          <Loader /> // Display loader while loading
        ) : viewMode === "board" ? (
          <IssueBoard
            ProjectID={project_id}
            allIssues={boardIssues}
            onRefresh={fetchIssues}
            loading={loading}
            searchTerm={boardSearchTerm}
          />
        ) : (
          <div className="row">
            <div className="col-12 ">
              <FilterSummaryBox
                onApply={handleApplyFilter}
                status_type="ISSUE"
                task_filter_id={project_id}
                // filter_path="/project/filter"
                filter_path="/issue/filter"
                has_view_type={true}
              />
            </div>
            
            <Box
              sx={{ width: "100%", height: Issues.length === 0 ? 300 : "100%" }}
              className="overflow-hidden"
            >
              <DataGrid
                rows={filteredIssues}
                columns={columns}
                onRowClick={handleRowClick}
                disableSelectionOnClick
                pagination
                paginationModel={paginationModel}
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                pageSizeOptions={[25, 50, 75, 100]}
                onPaginationModelChange={setPaginationModel}
                getRowId={(row) => row?.id || uniqueId}
              />

              {/* Menu for Action Button Options */}
              <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleView}>
                  <CiViewList className="me-2" color="blue" />
                  View Details
                </MenuItem>
                <MenuItem onClick={handleViewDitailstab}>
                  <CiViewList className="me-2" color="blue" />
                  View Details in New Tab
                </MenuItem>
                {selectedTask &&
                  (["ADMIN", "MANAGER"].includes(login_user_role) ||
                    Issues.find((issue) => issue.id === selectedTask?.id)
                      ?.added_by === login_user_id) && (
                    <div>
                      <CommonDeleteDialog
                        name="Issue"
                        url={"issue/delete"}
                        id={selectedTask?.id}
                        refetchList={fetchIssues}
                        handleListClose={handleMenuClose}
                        statusName={
                          Issues.find(
                            (issue) => issue.issue_id === selectedTask?.id
                          )?.title || "Issue"
                        }
                      />
                      <CommonTaskIssueNameChamge
                        name="Issue"
                        path="issue/update"
                        selectedTask={selectedTask}
                        setMenuAnchorEl={setMenuAnchorEl}
                        refetch_list={fetchIssues}
                      />
                    </div>
                  )}
              </Menu>
            </Box>
          </div>
        )}
      </div>
    </>
  );
};

export default IssueTab;
